import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Badge,
  Drawer,
  Typography,
  Dropdown,
  Modal,
  Grid,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import { ReactComponent as Logo } from "../../../assets/seller/icons/mobapartner.svg";
import { ReactComponent as BellIcon } from "../../../assets/seller/icons/bell_black_outline.svg";
import { ReactComponent as CrossIcon } from "../../../assets/seller/icons/x-close.svg";

import { ReactComponent as HomeblueIcon } from "../../../assets/seller/icons/homeblue.svg";
import "./Navbar.css";
import {
  HeaderContainer,
  OpenCloseButton,
  ProfileContainer,
  LeftContainer,
  LeftContainerMobile,
} from "./NavbarStyled";
import { useNavigate } from "react-router-dom";
import ProfileDropdown from "./ProfileDropDown/ProfileDropdown";

import { showDemandRupifiUrl } from "../../../commonUtils/commonUtils";
import { SellerMainSearch } from "../SellerMainSearch/SellerMainSearch";
import SellerRegistration from "../Sellerregisration/SellerRegistration";
import SellerNotification from "../SellerNotifications/SellerNotification";

import { useLazyGetStoreAccessDetailsQuery } from "../../../apis/Seller/SellerReportsAPI.js";
const { Title, Text } = Typography;

const ArrowTop = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.121"
    height="10.121"
    viewBox="0 0 10.121 10.121"
  >
    <path
      key="arrow-path-1"
      data-name="Line 113"
      transform="translate(1.061 1.061)"
      style={{
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5px",
      }}
      d="m0 8 8-8"
    />
    <path
      key="arrow-path-2"
      data-name="Path 45676"
      d="M7 7h8v8"
      style={{
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "1.5px",
      }}
      transform="translate(-5.939 -5.939)"
    />
  </svg>
);
const Navbar = ({ setCollapsed, collapsed }) => {
  const screens = Grid.useBreakpoint();
  const isDesktopViewport = !!screens.lg;

  const bmp_isactive = localStorage.getItem("bmp_isactive");
  const bmp_id = localStorage.getItem("bmp_id");
  const [NotificationCount, setNotificationCount] = useState(0);
  const url = new URL(`/home/product-search/${bmp_id}`, showDemandRupifiUrl);
  // url.searchParams.set("value", bmp_id);
  url.searchParams.set("bmp", bmp_id);
  const navigate = useNavigate();
  const handleNavigateDashboard = () => {
    const currentPath = window.location.pathname;
    const dashboardPath = "/seller/sellerdashboard";
    if (currentPath === dashboardPath) {
      window.location.reload();
    } else {
      navigate(dashboardPath);
    }
  };
  const [getStoreListAPI, { data: StoreList }] =
    useLazyGetStoreAccessDetailsQuery();
  useEffect(() => {
    getStoreListAPI();
  }, [getStoreListAPI]);

  const [isAddNewSellerModalOpen, setIsAddNewSellerModalOpen] = useState(false);

  const handleAddNewSellerModalClose = () => {
    setIsAddNewSellerModalOpen(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [visible, setVisible] = useState(false);
  const bmp_name = localStorage.getItem("bmp_name") || "";

  const [selectedVendor, setSelectedVendor] = useState(bmp_name);
  const dropdownItems = [
    ...(StoreList?.data?.flatMap((seller, index) => [
      {
        key: String(seller?.bmp_id || index),
        label: `${seller?.bmp_id} (${seller?.vendor_name})`,
        onClick: () => handleVendorChange(seller),
      },
      {
        type: "divider",
      },
    ]) || []),
    {
      key: "add-new-seller",
      label: (
        <div className="btn-add-newseller-list">
          <HomeblueIcon /> Add New Store
        </div>
      ),
      onClick: () => handleAddNewSeller(),
    },
  ];
  const handleAddNewSeller = () => {
    setIsAddNewSellerModalOpen(true);
  };
  const handleVendorChange = (newVendor) => {
    localStorage.setItem("bmp_id", newVendor?.bmp_id);
    localStorage.setItem("bmp_name", newVendor?.vendor_name);
    localStorage.setItem("bmp_isactive", newVendor?.is_active);
    setSelectedVendor(newVendor?.vendor_name);
    window.location.reload();
    // You can also add additional logic here, such as updating the URL or making an API call
  };
  const handleToggleSidebar = () => {
    setCollapsed((prevCollapsed) => !prevCollapsed);
  };
  return (
    <>
      {isDesktopViewport && (
        <HeaderContainer
          className="seller-navbar-desktop"
          style={{
            backgroundColor: "#fff",
            color: "#0a243f",
            boxShadow: "0 3px 3px 0 rgba(0, 0, 0, 0.08)",
            borderBottom: "1px solid #dedede ",
            padding: 0,
            height: "72px",
            minHeight: "72px",
          }}
        >
        <Row
          gutter={[16, 0]}
          style={{ margin: "0px" }}
          className="seller-navbar-row"
        >
          <Col
            xs={12}
            sm={24}
            md={7}
            lg={7}
            xl={7}
            className="seller-navbar-left-col"
          >
            <LeftContainer className="seller-navbar-left-content">
              <OpenCloseButton
                style={{ color: "#0a243f" }}
                onClick={handleToggleSidebar}
              >
                {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              </OpenCloseButton>
              <Logo
                style={{ cursor: "pointer", width: "120px" }}
                onClick={handleNavigateDashboard}
              />
              <div className="seller-navbar-store-trigger">
                <Dropdown
                  className="seller-vendor-dropdown"
                  menu={{ items: dropdownItems }}
                  trigger={["click"]}
                  placement="bottomLeft"
                  overlayClassName="seller-vendor-dropdown-overlay"
                >
                  <div className="seller-vendor-dropdown-trigger">
                    <span className="seller-vendor-dropdown-text">
                      {selectedVendor}
                    </span>
                    <DownOutlined className="profile-dropdown-styled-cursor" />
                  </div>
                </Dropdown>
              </div>
            </LeftContainer>
          </Col>

          <Col
            xs={24}
            sm={24}
            md={8}
            lg={8}
            xl={8}
            className="seller-navbar-search-col"
          >
            <SellerMainSearch />
          </Col>

          <Col
            xs={12}
            sm={24}
            md={9}
            lg={9}
            xl={9}
            className="header-control text-right seller-navbar-right-col"
            style={{paddingLeft: "2px"}}
          >
            <ProfileContainer className="seller-navbar-actions">
              {bmp_isactive === "true" && (
                <>
                  <Badge
                    key="online-store-badge"
                    size="small"
                    className="seller-online-store-wrap"
                  >
                    <a
                      key="online-store-badge-link"
                      href={url.href}
                      rel="noreferrer"
                      target="_blank"
                    >
                      <Text className="online-store seller-online-store">
                        Your online store {ArrowTop}
                      </Text>
                    </a>
                  </Badge>

                  <Badge
                    key="notification-badge"
                    size="small"
                    className="notification-badge seller-notification-wrap"
                    count={NotificationCount}
                  >
                    <Text
                      onClick={(e) => {
                        e.preventDefault();
                        setVisible(true);
                      }}
                      className="ant-dropdown-link"
                    >
                      <BellIcon />
                    </Text>
                  </Badge>
                </>
              )}
              <ProfileDropdown />
            </ProfileContainer>
          </Col>
        </Row>
        </HeaderContainer>
      )}

      {/* Mobile part */}
      {!isDesktopViewport && (
        <HeaderContainer
          className="pl-0"
        style={{
          backgroundColor: "#fff",
          color: "#0a243f",
          boxShadow: "0 3px 3px 0 rgba(0, 0, 0, 0.08)",
          borderBottom: "1px solid #dedede ",
          padding: "10px 0px 0px 0px",
          height: "120px",
        }}
      >
        <Row gutter={[24, 0]} style={{ margin: "0px" }}>
          <Col xs={13} sm={24} md={8} lg={8} xl={8} style={{ gap: "0rem" }}>
            <LeftContainerMobile>
              <OpenCloseButton
                style={{ color: "#0a243f", paddingLeft: "5px" }}
                onClick={handleToggleSidebar}
              >
                {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              </OpenCloseButton>
              <Logo
                style={{ cursor: "pointer", paddingBottom: "5px" }}
                onClick={handleNavigateDashboard}
              />
            </LeftContainerMobile>
          </Col>
          <Col
            xs={11}
            sm={24}
            md={8}
            lg={8}
            xl={8}
            className="header-control text-right"
          >
            <ProfileContainer>
              <ProfileDropdown />
            </ProfileContainer>
          </Col>
        </Row>
        <Row>
          <Col style={{ padding: "5px" }} xs={24} sm={24} md={8} lg={8} xl={8}>
            <SellerMainSearch />
          </Col>
        </Row>
        </HeaderContainer>
      )}

      <Drawer
        title={
          <Col
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Title level={4} style={{ margin: 0 }}>
              {NotificationCount} Notifications
            </Title>
            <Col
              onClick={() => setVisible(false)}
              style={{
                width: "48px",
                height: "48px",
                padding: "16px",
                borderRadius: " 24px",
                cursor: "pointer",
              }}
            >
              <CrossIcon />
            </Col>
          </Col>
        }
        placement="right"
        open={visible}
        className="notification-drawer"
        closable={false}
        onClose={() => setVisible(false)}
      >
        {/* drawer content */}
        <Row>
          <SellerNotification setNotificationCount={setNotificationCount} />
        </Row>
      </Drawer>
      <Modal
        title="Add New Store"
        open={isAddNewSellerModalOpen}
        onCancel={handleAddNewSellerModalClose}
        footer={[]}
      >
        <SellerRegistration
          handleAddNewSellerModalClose={handleAddNewSellerModalClose}
          reloadAPI={getStoreListAPI}
        />
      </Modal>
    </>
  );
};

export default Navbar;
